async function parseJson(response: Response) {
  return response.json().catch(() => null);
}

function extractErrorMessage(payload: any, fallback: string) {
  return payload?.error?.message || payload?.error || fallback;
}

export async function patchOrganization(organizationId: string, data: unknown) {
  const response = await fetch(`/api/v1/organizations/${organizationId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const json = await parseJson(response);
  if (!response.ok) {
    throw new Error(extractErrorMessage(json, "Failed to update organization"));
  }

  return json?.data;
}

export async function getOrganizationById(organizationId: string) {
  const response = await fetch(`/api/v1/organizations/${organizationId}`, {
    method: "GET",
  });

  const json = await parseJson(response);
  if (!response.ok) {
    const error = new Error(extractErrorMessage(json, "Failed to fetch organization")) as Error & {
      status?: number;
    };
    error.status = response.status;
    throw error;
  }

  return json?.data;
}

export async function createOrganization(data: unknown) {
  const response = await fetch("/api/v1/organizations", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const json = await parseJson(response);
  if (!response.ok) {
    throw new Error(extractErrorMessage(json, "Failed to create organization"));
  }

  return json?.data;
}

export async function deleteOrganizationById(organizationId: string) {
  const response = await fetch(`/api/v1/organizations/${organizationId}`, {
    method: "DELETE",
  });

  const json = await parseJson(response);
  if (!response.ok) {
    throw new Error(extractErrorMessage(json, "Failed to delete organization"));
  }

  return json?.data;
}
